import {
	getCountryNameByIso2,
	getIso2FromCountryName,
} from 'shared/utils/countryNameByIso2'
import { getStudentApplicationCountryLabel } from './studentApplicationCountries'

/** Short labels for table cells (long official names abbreviated). */
const SHORT_LABEL_BY_ISO2 = {
	US: 'USA',
	GB: 'UK',
	AE: 'UAE',
	SA: 'Saudi',
	KR: 'S. Korea',
	NZ: 'NZ',
	VN: 'Vietnam',
	MY: 'Malaysia',
	ID: 'Indonesia',
	SG: 'Singapore',
	JP: 'Japan',
	DE: 'Germany',
	AU: 'Australia',
	IE: 'Ireland',
	CA: 'Canada',
	FR: 'France',
	IN: 'India',
	CN: 'China',
}

export const MAX_VISIBLE_STUDENT_COUNTRIES = 3

export const getStudentCountryShortLabel = code => {
	if (code == null || code === '') return ''
	const key = String(code).trim().toUpperCase()
	return (
		SHORT_LABEL_BY_ISO2[key] ||
		getStudentApplicationCountryLabel(key) ||
		getCountryNameByIso2(key) ||
		key
	)
}

/**
 * Prefer full target_countries list (ISO2); else single country / dream_country.
 */
export const resolveStudentCountryIso2List = student => {
	const targets = Array.isArray(student?.target_countries)
		? student.target_countries
		: []

	const fromTargets = [
		...new Set(
			targets
				.flatMap(item => String(item || '').split(','))
				.map(item => item.trim())
				.filter(Boolean)
				.map(item => getIso2FromCountryName(item))
				.filter(Boolean),
		),
	]

	if (fromTargets.length) return fromTargets

	const fallback =
		getIso2FromCountryName(student?.country) ||
		getIso2FromCountryName(student?.dream_country)

	return fallback ? [fallback] : []
}

export const getStudentCountriesDisplay = student => {
	const codes = resolveStudentCountryIso2List(student)
	const visible = codes.slice(0, MAX_VISIBLE_STUDENT_COUNTRIES)
	const moreCount = Math.max(0, codes.length - MAX_VISIBLE_STUDENT_COUNTRIES)

	return {
		codes,
		visible,
		moreCount,
		items: visible.map(code => ({
			code,
			label: getStudentCountryShortLabel(code),
		})),
	}
}
